export default __webpack_public_path__ + "static/media/help_3_keyboard.156deef0.gif";